<template>
  <div class="d-flex align-items-center min-vh-100">
    <CContainer fluid>
      <CRow class="justify-content-center">
        <CCol md="5">
          <CCard class="mx-4 mb-0">
            <CCardBody class="p-4">
              <CForm>
                <CRow>
                  <CCol md="12">
                    <img src="img/logos/logo-azul-texto.png" class="rounded mx-auto d-block logo"/>
                  </CCol>
                </CRow>
                <CRow>
                  <CCol md="12">
                    <h5>Seja bem-vindo <strong>{{form.name | firstName}}</strong>!</h5><br/>
                  </CCol>
                </CRow>
                <CRow>
                  <CCol md="12">
                    <p>
                      Para que possamos liberar seu acesso à plataforma, precisamos primeiramente que você <strong>realize a confirmação de seu email</strong>.<br/>
                      Para isso, uma mensagem foi enviada para o endereço cadastrado ({{form.email}}).<br/> <br/> - Não esqueça de verificar a caixa de SPAM.
                    </p>
                  </CCol>
                </CRow>
                <CRow>
                  <CCol md="6">
                    <center>
                      <CButton color="danger" block @click="logout">
                        <CIcon name="cil-exit-to-app" />&nbsp;&nbsp;
                        Sair
                      </CButton>
                    </center>
                  </CCol>
                  <CCol md="6">
                    <center>
                      <CButton color="primary" block @click="resend">
                        <CIcon name="cil-link" />&nbsp;&nbsp;
                        Enviar novo email
                      </CButton>
                    </center>
                  </CCol>
                </CRow>           
              </CForm>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>

<script>
export default {
  name: 'Register',
  filters() {
    firstName = (v) => {
      v = v.split(' ')
      return v[0]
    }
  },
  data () {
    return {
      form: {
        name: '',
        email: '',
        password: '',
        password_confirmation: '',
      }
    }
  },
  mounted() {
    this.info()
  },
  methods: {
    resend() {
      this.$loading(true)
      this.$http.get('/api/email/resend')
      .then(res => {
        if (res.status === 202)
        {
          this.$swal({
            icon: 'success',
            title: 'Atenção!',
            text: 'Um novo email de validação foi enviado.',
          })
        }
        this.$loading(false)
      })
      .catch(error => {
          
      });
    },
    info() {
      this.$loading(true)
      this.$http.get('/api/user')
      .then(res => {
        if (res.data.email_verified_at !== null)
        {
          // Atualiza state
          let user = this.$store.state.user
          user.email_verified_at = res.data.email_verified_at
          this.$store.commit('set', ['user', user])
          // Dashboard
          this.$router.push({name: 'Dashboard'})
        } else {
          this.form = res.data
        }
        this.$loading(false)
      })
      .catch(error => {
          
      });
    },
    logout() {
      this.$http.get('/logout').then(() => {
        this.$router.push({'path': '/login'})
      })
    }
  }
}
</script>
<style scoped>
.logo{
  padding-bottom: 25px;
}
</style>